import styled from '@emotion/styled';

import Button from '~/scripts/components/Button';

export const MapHeightHolder = styled.div`
  height: ${({ mobileHeight = 400 }) =>
    typeof mobileHeight === 'number' ? mobileHeight + 'px' : mobileHeight};
  .map {
    height: ${({ mobileHeight = 400 }) =>
      typeof mobileHeight === 'number' ? mobileHeight + 'px' : mobileHeight};
  }
  ${(p) => p.theme.breakpoints.sm.up} {
    height: ${({ desktopHeight = 600 }) =>
      typeof desktopHeight === 'number' ? desktopHeight + 'px' : desktopHeight};
    .map {
      height: ${({ desktopHeight = 600 }) =>
        typeof desktopHeight === 'number' ? desktopHeight + 'px' : desktopHeight};
    }
  }
  .map {
    background: #fff;
  }
`;

export const MapToggle = styled(Button)`
  z-index: 1000;
  position: absolute;
  top: ${({ top = '10px' }) => top};
  right: ${({ right = '10px' }) => right};
  bottom: ${({ bottom = 'unset' }) => bottom};
  left: ${({ left = 'unset' }) => left};
  width: 120px;
  display: flex;
  text-align: left;
  align-items: center;
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }

  .icon {
    font-size: 24px;
    color: ${(p) => p.theme.colors.lightText};
    margin-left: -2px;
    margin-right: 8px;
  }
`;
